import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ValidationDialogComponent } from '../../../../basket/validation-dialog/validation-dialog.component';

@Component({
  selector: 'app-besoin-statut-help',
  templateUrl: './besoin-statut-help.component.html',
  styleUrls: ['./besoin-statut-help.component.scss']
})
export class BesoinStatutHelpComponent {
  constructor(
    private dialogRef: MatDialogRef<ValidationDialogComponent>
  ) { }

  refuse() {
    this.dialogRef.close(false);
  }
}